import gql from 'graphql-tag'

export default gql`
mutation ($slug: String!, $progressDistance: Int,$typeUser: [String], $gender: String!, $limit: Int) {
  exportProgressDistanceOrLimit(slug: $slug, progressDistance: $progressDistance, typeUser:$typeUser, gender: $gender, limit: $limit) {
    downloadUrl
  }
}
`
